import React from "react"
import {
  InputGroup,
  InputLeftAddon,
  NumberInput as ChakraNumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  Text,
  LayoutProps,
} from "@chakra-ui/react"

type Props = {
  value: string | number
  onChange: (valueStr: string) => void
  label?: string
  min?: number
  max?: number
  step?: number
  precision?: number
  size?: "sm" | "md" | "lg"
  format?: (val: string | number) => string
  parse?: (val: string) => string
  disabled?: boolean
  w?: LayoutProps["w"]
  placeholder?: string
  onBlur?: () => void
  /** Chakra brings the value within min and max when the field is left. */
  clampValueOnBlur?: boolean
}

const NumberInput = ({
  value, onChange, label, min, max, step, precision,
  size = "sm", format: formatFn, parse, disabled, w, placeholder, onBlur,
  clampValueOnBlur,
}: Props) => (
  <InputGroup size={size}>
    {label && (
      <InputLeftAddon
        bg="gray.50"
        borderColor="gray.300"
        color="gray.600"
        fontWeight="medium"
        px={size === "sm" ? 1.5 : 2}
        minW="24px"
        justifyContent="center"
        fontSize={size === "sm" ? "2xs" : "xs"}
        borderRight="none"
        borderLeftRadius="md"
      >
        <Text fontFamily="monospace" fontSize={size === "sm" ? "2xs" : "xs"}>{label}</Text>
      </InputLeftAddon>
    )}
    <ChakraNumberInput
      value={value}
      onChange={onChange}
      min={min}
      max={max}
      step={step}
      precision={precision}
      format={formatFn}
      parse={parse}
      size={size}
      w={w ?? "full"}
      isDisabled={disabled}
      onBlur={onBlur}
      clampValueOnBlur={clampValueOnBlur}
    >
      <NumberInputField
        bg="white"
        borderRadius="md"
        borderLeftRadius={label ? 0 : undefined}
        fontSize="sm"
        px={size === "sm" ? 1.5 : 2}
        placeholder={placeholder}
      />
      <NumberInputStepper>
        <NumberIncrementStepper />
        <NumberDecrementStepper />
      </NumberInputStepper>
    </ChakraNumberInput>
  </InputGroup>
)

export default NumberInput
